import moment from 'moment';
import {
  createColumnsV2Common,
  createV2CommonFilters,
} from '../../../../aspects/V2CommonFields';
import {
  createColumnsV2Orders,
  createV2OrdersFilters,
} from '../../../../aspects/V2OrderFields';
import { CommonList } from '../../../../shared';

/**
 * Declare the additional columns to display (aspects)
 */
const columns: any[] = [...createColumnsV2Orders(), ...createColumnsV2Common()];

/**
 * Specific filters for orders
 */
const additionalFilters: any[] = [
  ...createV2CommonFilters(),
  ...createV2OrdersFilters(),
];

/**
 * Order list component
 */
const DxV2OrderList = (props) => {
  return (
    <CommonList
      title='dxMessages.invoices.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      filterDefaultValues={{
        ingestDateAfter: moment()
          .subtract(4, 'hours')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      }}
    />
  );
};

export default DxV2OrderList;
